import { useState } from "react";
import { ALBUMSCARD } from "../constants/albums"
import { WinningCard } from "../lib/localStorage";
import { CardsModal } from "./modals/CardsModal";

type Props = {
    cards: WinningCard[],
}

export const Collection = ({ cards }: Props) => {

    const albumStats: any[] = [];
    const [selectedCards, setSelectedCards] = useState<WinningCard[] | null>(null)
    const [isCardsModalOpen, setIsCardsModalOpen] = useState(false)

    ALBUMSCARD.map((album) => {
        if (cards == null) {
            albumStats.push({
                id: album.id,
                image: album.image,
                stats: 0
            })
        } else {
            const stats = cards.filter((card) => card.albumid == album.id).length;
            albumStats.push({
                id: album.id,
                image: album.image,
                stats: stats
            })
        }
    })
    return (
        <div className="mb-28 flex flex-col justify-center items-center">
            <div className="text-white font-bold mb-5 justify-center items-center">
                Your collection
            </div>
            <div className="grid grid-cols-4 gap-3 mb-5">
                {albumStats.map((e) => {
                    return <div className='relative overflow-hidden cursor-pointer' onClick={() => {
                        if (e.stats > 0) {
                            setSelectedCards(cards.filter((card) => card.albumid == e.id))
                            setIsCardsModalOpen(true)
                        }
                    }}>
                        <img className={e.stats > 0 ? 'opacity-50 object-cover h-20 w-20 mb-3 rounded-full' : 'opacity-10 object-cover h-20 w-20 mb-3 rounded-full'} src={e.image} />
                        {e.stats > 0 ?
                            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                                <div className="text-white font-bold mb-5 justify-center items-center">
                                    {e.stats >= 7 ? '💜' : e.stats + ' / 7'} 
                                </div>
                            </div> : <div></div>
                        }
                    </div>
                })}
            </div>
            <div className="text-slate-600 text-xs font-bold mb-5 justify-center items-center">
                COPYRIGHT © 2021 BIG HIT MUSIC / HYBE. ALL RIGHTS RESERVED
            </div>
            <CardsModal
                isOpen={isCardsModalOpen}
                handleClose={() => setIsCardsModalOpen(false)}
                cards={selectedCards}
            />
        </div>
    )
}